module.exports = __webpack_public_path__ + "static/media/03-05.8d1c5e27.png";